import {IStatusRepository} from "@/repository/status/StatusRepository.types";
import {IStatus, StatusResponseType} from "@/entity/status/status.types";
import Api from "@/repository/api";
import Status from "@/entity/status/status";
import {ResponseDataType} from "@/form/form.types";

export class StatusRepository implements IStatusRepository {
    async fetchAll(): Promise<IStatus[]> {
        const resp = await Api.get('/staff/status/get');
        const respData = resp.data as StatusResponseType[];
        return respData.map((status: StatusResponseType) => new Status(status));
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const res = await Api.post('/staff/status/delete', data);
        return res.data;
    }
}